// Gedeeld door de homepage en productpagina: menu, kaarten en video's.
(() => {
  const strings = window.FS_T || {};
  const translate = (template, values = {}) => Object.entries(values).reduce(
    (text, [key, value]) => text.replaceAll(`__${key.toUpperCase()}__`, value),
    template || "",
  );
  const menu = document.querySelector("[data-menu]");
  const nav = document.getElementById("nav");

  if (menu && nav) {
    const close = () => {
      nav.classList.remove("is-open");
      menu.setAttribute("aria-expanded", "false");
      menu.textContent = strings.menu || "Menu";
    };

    menu.addEventListener("click", () => {
      const open = !nav.classList.contains("is-open");
      nav.classList.toggle("is-open", open);
      menu.setAttribute("aria-expanded", String(open));
      menu.textContent = open ? strings.close : strings.menu;
    });

    nav.addEventListener("click", (event) => {
      if (event.target.closest("a")) close();
    });

    addEventListener("keydown", (event) => {
      if (event.key === "Escape" && nav.classList.contains("is-open")) {
        close();
        menu.focus();
      }
    });
  }

  document.querySelectorAll("[data-card-colour]").forEach((button) => {
    button.addEventListener("click", () => {
      const card = button.closest("[data-product-card]");
      const colour = button.dataset.cardColour;
      card.dataset.colour = colour;

      card.querySelectorAll(".card-img img[data-side]").forEach((image) => {
        const base = `${card.dataset.handle}-${colour}-${image.dataset.side}`;
        image.src = `${window.FS_ASSET_BASE}${base}-800.webp`;
        image.srcset = [560, 800, 1000]
          .map((width) => `${window.FS_ASSET_BASE}${base}-${width}.webp ${width}w`)
          .join(", ");
      });

      const front = card.querySelector(".front");
      if (front) front.alt = `${card.querySelector(".card-name").textContent.trim()}, ${colour === "black" ? strings.black : strings.white}`;

      card.querySelectorAll("[data-card-colour]").forEach((item) => {
        item.setAttribute("aria-pressed", String(item === button));
      });

      card.querySelectorAll("a").forEach((link) => {
        const url = new URL(link.href, location.origin);
        url.searchParams.set("color", colour);
        link.href = url;
      });
    });
  });

  // Autoplay waar het kan; klikken en toetsen blijven altijd beschikbaar.
  const videos = [...document.querySelectorAll("video[data-auto-video]")];
  if (!videos.length) return;

  const note = document.querySelector("[data-video-note]");
  const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const play = (video) => video.play().catch(() => {
    if (note) note.hidden = false;
  });
  const toggle = (video) => (video.paused ? play(video) : video.pause());

  if (reduceMotion) {
    if (note) note.hidden = false;
  } else if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) play(target);
        else target.pause();
      });
    }, { threshold: 0.4 });
    videos.forEach((video) => observer.observe(video));
  }

  videos.forEach((video) => {
    video.addEventListener("playing", () => (video.dataset.played = "true"));

    // Video in een shoplink (homepage): klikken gaat naar het shirt. Speelt hij nog niet
    // (autoplay geblokkeerd), dan start de eerste tik de video.
    const link = video.closest("[data-video-link]");
    if (link) {
      link.addEventListener("click", (event) => {
        if (video.paused && !video.dataset.played) {
          event.preventDefault();
          play(video);
        }
      });
      return;
    }

    const description = video.getAttribute("aria-label") || "video";
    video.tabIndex = 0;
    video.setAttribute("role", "button");
    video.setAttribute("aria-label", translate(strings.playVideo, { description }));
    video.setAttribute("aria-pressed", "false");
    video.addEventListener("play", () => video.setAttribute("aria-pressed", "true"));
    video.addEventListener("pause", () => video.setAttribute("aria-pressed", "false"));
    video.addEventListener("click", () => toggle(video));
    video.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        toggle(video);
      }
    });
  });
})();
